module.exports = __webpack_public_path__ + "img/favicon.5ed767a3.png";